import { useEffect, useRef, useState } from "react";
import { useLoaderData } from "react-router-dom";
import { MdEdit, MdDelete, MdAdd, MdArrowBack } from "react-icons/md";
import { toast } from "react-toastify";
import { Button } from "../../components/Button";
import {
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import { DataGridBase } from "../../components/DataGrid/DataGridBase";
import { useNavigate } from "react-router-dom";
import { Select } from "../../components/Select";
import { Input } from "../../components/Input";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import moment from "moment";
import { SlOptionsVertical } from "react-icons/sl";
import Modal from "../../components/Modal";
import {
  HiMiniArrowDownTray,
  HiOutlineCheck,
  HiOutlinePlus,
  HiOutlineTrash,
  HiOutlineXMark,
  HiPlus,
} from "react-icons/hi2";
import { PrincipalButton } from "../../components/PrincipalButton";
import api from "../../api/api";
import { CustomCheckbox } from "../../components/Checkbox";

export const CCNL = ({ screenSize }) => {
  const [raccordi, setRaccordi] = useState([]);
  const [ipsoaSel, setIpsoaSel] = useState(null);
  const [tipologia, setTipologia] = useState("");

  const columns = [
    {
      field: "Azioni",
      headerName: "Azioni",

      headerAlign: "center",
      align: "center",
      filterable: false,
      renderCell: (params) => {
        return (
          <>
            <Button
              className="edit-button "
              type="button"
              icon={<MdEdit className="button-icon" />}
              onClick={async () => {
                setTipologia("modifica");
                setIpsoaSel(params.row);
              }}
            />
            <Button
              className="delete-button "
              type="button"
              icon={<MdDelete className="button-icon" />}
              onClick={async () => {
                setTipologia("elimina");
                setIpsoaSel(params.row);
              }}
            />
          </>
        );
      },
    },
    {
      field: "codice_contratto",
      headerName: "Codice contratto",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "codice_cnel",
      headerName: "Codice CNEL",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "descrizione",
      headerName: "Descrizione",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
  ];
  useEffect(() => {}, [screenSize]);

  const loadRaccordi = async () => {
    const prest = await api.get("/ipsoa");
    setRaccordi(prest.data);
  };

  useEffect(() => {
    //carico clienti subito
    loadRaccordi();

    //
  }, []);

  useEffect(() => {
    if (ipsoaSel && tipologia == "modifica") {
      document.getElementById("editRaccordo").click();
    }
    if (ipsoaSel && tipologia == "elimina") {
      document.getElementById("deleteRaccordo").click();
    }
  }, [ipsoaSel, tipologia]);

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <div className="w-full flex flex-wrap-reverse md:flex-nowrap justify-between md:space-x-5 mb-2 gap-y-1">
          <div className="flex md:flex-nowrap md:w-fit w-full flex-wrap justify-center md:justify-start gap-x-2">
            <GridToolbarQuickFilter placeholder="Cerca..." />
          </div>
          <div className="flex justify-center md:justify-end md:mx-0 mx-auto">
            <ModalPrestazione
              tipologia={"inserimento"}
              loadRaccordi={loadRaccordi}
            />
          </div>
        </div>
      </GridToolbarContainer>
    );
  }

  return (
    <div className="el-container h-fit ">
      <ModalPrestazione
        tipologia={"modifica"}
        ipsoaSel={ipsoaSel}
        loadRaccordi={loadRaccordi}
      />
      <ModalPrestazione
        tipologia={"elimina"}
        ipsoaSel={ipsoaSel}
        loadRaccordi={loadRaccordi}
      />

      <div className="w-full md:h-[70vh] h-[70vh] relative el-container">
        <DataGridBase
          storageKey="anagrafica_ccnl"
          slots={{ toolbar: CustomToolbar }}
          columns={columns}
          rows={raccordi}
          getRowId={(r) => r.ID}
        />
      </div>
    </div>
  );
};

const ModalPrestazione = ({ tipologia, ipsoaSel, loadRaccordi }) => {
  const [open, setOpen] = useState(false);
  const [ipsoa, setIpsoa] = useState(null);

  const handleOpenModal = () => {
    if (tipologia === "modifica" || tipologia === "elimina") {
      setIpsoa(ipsoaSel);
    } else {
      setIpsoa({
        codice_cnel: "",
        codice_contratto: "",
        descrizione: "",
      });
    }
    setOpen(true);
  };
  const handleChange = (e) => {
    let i = { ...ipsoa };
    i[e.target.name] = e.target.value;
    setIpsoa(i);
  };
  const handleSave = async () => {
    try {
      if (tipologia === "inserimento") {
        await api.post("/ipsoa", { ipsoa: ipsoa });

        toast.success("Raccordo inserito con successo");
      } else if (tipologia == "modifica") {
        await api.put("/ipsoa", { ipsoa: ipsoa });
        toast.success("Raccordo modificato con successo");
      } else {
        await api.delete("/ipsoa/" + ipsoa.ID);
        toast.success("Raccordo eliminato con successo");
      }
      loadRaccordi();
      setOpen(false);
    } catch {
      toast.error("Errore durante il salvataggio");
    }
  };

  return (
    <>
      {tipologia === "inserimento" ? (
        <Button
          className="success-button"
          text="Aggiungi"
          type="button"
          icon={<HiPlus className="button-icon" />}
          onClick={async () => {
            handleOpenModal();
          }}
        />
      ) : tipologia == "modifica" ? (
        <Button
          className="hidden"
          id="editRaccordo"
          type="button"
          icon={<MdEdit className="button-icon " />}
          onClick={async () => {
            handleOpenModal();
          }}
        />
      ) : (
        <Button
          className="hidden"
          id="deleteRaccordo"
          type="button"
          icon={<MdEdit className="button-icon " />}
          onClick={async () => {
            handleOpenModal();
          }}
        />
      )}
      <Modal
        isOpen={open}
        closeButton={() => setOpen(false)}
        headerText={`${tipologia} Raccordo Ipsoa`}
        size={"medium"}
        leftButtons={
          <Button
            className="principal-button"
            text="Salva"
            type="button"
            icon={<HiOutlineCheck className="button-icon" />}
            onClick={async () => {
              handleSave();
            }}
          />
        }
      >
        {tipologia == "elimina" ? (
          <>Sei sicuro di voler eliminare il raccordo {ipsoa?.descrizione}</>
        ) : (
          <div className="grid grid-cols-2 gap-2">
            <div className="col-span-1 ">
              <Input
                type="text"
                label={"Codice contratto"}
                name="codice_contratto"
                onChange={(e) => handleChange(e)}
                value={ipsoa?.codice_contratto}
              />
            </div>
            <div className="col-span-1 ">
              <Input
                type="text"
                label={"Codice CNEL"}
                name="codice_cnel"
                onChange={(e) => handleChange(e)}
                value={ipsoa?.codice_cnel}
              />
            </div>
            <div className="col-span-2 ">
              <Input
                type="text"
                label={"Descrizione"}
                name="descrizione"
                onChange={(e) => handleChange(e)}
                value={ipsoa?.descrizione}
              />
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};
